import React from "react";
import { Navlist } from "./Navlist";
import { Link } from "react-scroll";
import "./Navbar.css";
import { useState } from "react";

const Navbar = () => {
  const [items, setItems] = useState("1");
  return (
    <div className="nav">
      <ul className="nav-items">
        {Navlist.map((item) => {
          return (
            <li key={item.id}>
              <Link
                to={item.connection}
                spy={true}
                smooth={true}
                offset={50}
                duration={500}
              >
                <img
                  onClick={() => {
                    setItems(item.id);
                  }}
                  className={
                    items === item.id ? item.cName + "-clicked" : item.cName
                  }
                  src={item.name}
                  alt=""
                />
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Navbar;
